var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ListItem from '../../../../components/List/ListItem';
var dropdownItemStyles = {
    root: function (_a) {
        var v = _a.variables, active = _a.props.active;
        var _b, _c;
        return (__assign((_b = {}, _b["&." + ListItem.className] = { backgroundColor: v.listItemBackgroundColor }, _b), (active && (_c = {},
            _c["&." + ListItem.className] = {
                backgroundColor: v.listItemHighlightedBackgroundColor,
                color: v.listItemHighlightedTextColor,
            },
            _c))));
    },
};
export default dropdownItemStyles;
